export enum EDocumentsQueryKey {
  DOCUMENTS_UPLOAD = 'DOCUMENTS_UPLOAD',
  DOCUMENTS = 'DOCUMENTS',
  NOTES = 'NOTES',
  PAGE_COUNT = 'PAGE_COUNT',
}
